module.exports = __webpack_public_path__ + "media/images/banner-3aed8a9e74a60134b46012378aa4a78c.webp";